var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-component',{attrs:{"navigation-group":_vm.navigationGroup,"product-subcategories":_vm.productSubcategories},on:{"onSubmit":_vm.onSubmit,"fetchByLocale":_vm.fetchByLocale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }